export const first = <><strong>Collect</strong> NFTs from the smart contract to your wallet.</>;

export default function() {
  return <div>
    <div>{first}</div>
    <div>You may have to opt in to the corresponding CupStakes NFT IDs.</div>
    <div>Note: You can not burn CupStakes after you have collected them into your wallet.</div>
  </div>;
}
